import React from 'react'
import { MainPageView } from './components'

const App = () => {
  return <MainPageView />
}

export default App
